<template>
  <div class="act_miaosha">


    <ActCountDown v-if="status===0" :diff="diff" :text_color="info.miao_cd_text_color"
                  :num_color="info.miao_cd_num_color"
                  :num_bg="info.miao_cd_num_bg"></ActCountDown>

    <ActCountDown v-else :diff="0" :text_color="info.miao_cd_text_color" :num_color="info.miao_cd_num_color"
                  :num_bg="info.miao_cd_num_bg"></ActCountDown>

    <div style="height: .2rem;"></div>
    <ActPaomadeng
      :records="records"
      :color="info.miao_pmd_color"
      :bg="info.miao_pmd_bg"
    ></ActPaomadeng>

    <div class="button" @click="clickButton" :style="buttonStyle"></div>
    <div class="tip" v-if="need_level >= 0" :style="tipStyle">
        <span v-if="status === 2">
          秒杀已结束
        </span>
      <span v-else-if="!is_login">
                仅限V{{need_level}}+会员参与，<span style="text-decoration:underline;" @click="toLogin">请登录</span>
            </span>
      <span v-else-if="!has_right">
                仅限V{{need_level}}+会员参与，<span style="text-decoration:underline;" @click="toCashier">请升级</span>
            </span>
      <span v-else>
                您是V{{need_level}}+会员，恭喜获得秒杀资格
      </span>
    </div>
    <div v-else class="tip" :style="tipStyle">
         <span v-if="status === 2">
          秒杀已结束
        </span>
    </div>
  </div>
</template>
<script>
  import {getJSON} from '../../api/myaxios';
  import {setAccurateInterval} from '../../tools/interval'
  import ActCountDown from './ActCountDown'
  import ActPaomadeng from './ActPaomadeng'
  import {login} from '../../tools/mgtv/login'
  import to_casher from '../../tools/mgtv/casher'
  import click_handler from '../../tools/mgtv/click'
  import process_award from './Lottery/process_award'
  import preload from '../../tools/preload'

  //http://wiki.imgo.tv/pages/viewpage.action?pageId=6324415#id-%E6%B4%BB%E5%8A%A8%E5%90%8E%E5%8F%B0%E7%AE%A1%E7%90%86%E7%B3%BB%E7%BB%9F-%E4%B9%90%E9%AB%98-%E7%A7%92%E6%9D%80

  let count_times = 0;
  const COUNT_MAX = 10;

  export default {
    name: 'ActMiaoSha',
    components: {
      ActCountDown,
      ActPaomadeng
    },
    props: {
      info: {}
    },
    data() {
      return {
        interval: null,
        status: 0, //0未开始，1秒杀中，2活动已结束
        diff: 0, //开始秒杀倒计时
        need_level: -1, //需要vip等级，-1则不需要
        records: null, //中奖名单
      }
    },
    methods: {
      getActStat() {
        //设置一个最大调用次数，以防返回值错误后循环调用把服务器冲垮
        if (count_times > COUNT_MAX) { //10次
          return;
        }
        count_times += 1;
        getJSON('//vipact3.api.mgtv.com/api/v1/act/miaosha/down', {
          act_name: window.rootdata.act_name,
          sub_act_id: `lego${this.info.id}`,
          t: new Date().getTime()
        }).then(res => {
          if (!res) {
            setTimeout(this.getActStat, 2000);
            return;
          }
          // res = {
          //   ret: 0,
          //   data: {
          //     status: 0,
          //     diff: 0,
          //     need_level: 5,
          //   }
          // }
          if (res.ret === 0) {
            this.status = res.data.status;
            this.diff = res.data.diff;
            this.need_level = parseInt(res.data.need_level)

            //状态为0时是显示距离秒杀开始的时间
            //状态为1时是秒杀中，diff=秒杀持续时间，5s左右
            //状态为2时 diff=-1,秒杀活动结束，不需要倒计时

            if (this.diff >= 0) {
              this.startCountDonw();
            }


          }
        })
      },
      getAwardUsers() {
        getJSON('//vipact3.api.mgtv.com/api/v1/act/miaosha/pmd', {
          act_name: window.rootdata.act_name,
          sub_act_id: `lego${this.info.id}`
        }).then(res => {
          if (res.ret === 0) {
            if (!res.data.list) {
              return
            }
            this.records = res.data.list.map(item => {
              return `恭喜${item.nickname}获得了${item.award_name}`
            })

          }
        });

      },
      startCountDonw() {
        this.interval = setAccurateInterval(() => {
          this.diff -= 10;
          if (this.diff <= 0) {
            this.interval.clear();
            this.getActStat();
          }
        }, 10);
      },
      clickButton() {
        console.log('clickButton')
        if (this.status !== 1) {
          console.log('秒杀未开始')
          return;
        }

        click_handler(`${this.info.name}-秒杀按钮`, () => {
          window.$toast.loading({
            mask: false,
            forbidClick: true, // 禁用背景点击
            message: '正在秒杀',
            duration: 10000
          });
          const randomNum = Math.random();
          if (randomNum < 0.9) {
            setTimeout(() => {
              this.miaoshaApi();
            }, randomNum * 3000);
          } else {
            this.miaoshaApi();
          }
        }, {
          need_login: true,
          need_act: true,
          need_vip_level: this.need_level, //需要VIP等级
          need_new_user: false
        })
      },
      miaoshaApi() {
        console.log('miaoshaApi')
        getJSON('//vipact3.api.mgtv.com/api/v1/act/miaosha/ms', {
          act_name: window.rootdata.act_name,
          sub_act_id: `lego${this.info.id}`,
          ticket: window.$bus.user.ticket
        }).then(res => {
          setTimeout(() => {
            window.$toast.clear();
            if (!res) {
              window.$toast('很遗憾，没有秒杀到');
              return;
            }
            if (res.ret === 0) {
              //获取奖品
              process_award(res.data.award_info);
            } else {
              window.$toast('很遗憾，没有秒杀到');
            }
          }, 2000);
        }).catch(e => {
          setTimeout(() => {
            window.$toast.clear();
            window.$toast('很遗憾，没有秒杀到');
          }, 2000);
        })

      },
      toCashier() {
        click_handler(`${this.info.name}-点击文案去升级`, () => {
          to_casher();
        }, {
          need_login: false,
          need_act: true,
          need_vip_level: -1,
          need_new_user: false
        })
      },
      toLogin() {
        click_handler(`${this.info.name}-点击文案去登陆`, () => {
          login();
        }, {
          need_login: false,
          need_act: true,
          need_vip_level: -1,
          need_new_user: false
        })
      },
    },
    created() {
      preload([
        this.info.miao_btn
      ])
      this.getActStat();
      this.getAwardUsers();
    },

    mounted() {

    },
    computed: {
      buttonStyle() {
        if (this.status === 1) {
          return {
            background: `url(${this.info.miao_btn}) 0% 0% / cover no-repeat`
          }
        }
        return {
          background: `url(${this.info.miao_btn_drak}) 0% 0% / cover no-repeat`
        }
      },
      is_login() {
        return !!window.$bus.user.ticket
      },
      has_right() {//是否有抽奖资格
        if (this.need_level >= 0) {
          if (window.$bus.vip_id === 0) {
            return false
          }
          return window.$bus.user.level >= this.need_level
        }
        return true
      },
      tipStyle() {
        return {
          color: `${this.info.miao_tip_color} !important`
        }
      },
    },
    watch: {}
  }
</script>
<style lang="stylus" scoped>
  .act_miaosha
    position relative
    width 7.5rem
    .button
      position relative
      width 4.35rem
      height 1.26rem
      margin .1rem auto 0
    .tip
      width 100%
      text-align center
      margin .1rem auto 0
      font-size .28rem
</style>






// WEBPACK FOOTER //
// src/components/ConfigUI/ActMiaoSha.vue